import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgImportIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 14"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M1.616 14q-.69 0-1.153-.462-.462-.462-.463-1.154v-1.923q0-.213.143-.356A.49.49 0 0 1 .5 9.961q.215 0 .357.144a.49.49 0 0 1 .143.356v1.923q0 .23.192.424a.58.58 0 0 0 .423.192h10.77a.6.6 0 0 0 .423-.192.58.58 0 0 0 .192-.424v-1.923q0-.213.143-.356a.49.49 0 0 1 .357-.144q.215 0 .357.144a.49.49 0 0 1 .143.356v1.923q0 .69-.462 1.153-.462.462-1.154.463zM6.5 1.927 4.529 3.898a.5.5 0 0 1-.347.153.48.48 0 0 1-.366-.159.51.51 0 0 1-.163-.353.48.48 0 0 1 .163-.354L6.434.565a.8.8 0 0 1 .268-.183A.8.8 0 0 1 7 .33q.161 0 .298.053t.268.184l2.618 2.62q.148.144.154.343a.5.5 0 0 1-.153.363.51.51 0 0 1-.357.17.49.49 0 0 1-.357-.164L7.5 1.928v8.15a.48.48 0 0 1-.143.356.49.49 0 0 1-.357.143.49.49 0 0 1-.357-.143.48.48 0 0 1-.143-.357z"
    />
  </svg>
)
export default SvgImportIcon
